import { hexToRgba } from 'utils';
import styles from './styles.module.scss';
import { Icons } from 'pages/Profile/components/icons';
import { Notifications } from 'pages/Settings/Notifications';

const NotificationsContent = ({
  contactId,
  contactName,
  notificationPref,
  disableTextNotification,
  disableAll,
}) => {
  return (
    <div className={styles.notificationsContent}>
      {disableAll && (
        <div className={styles.banner}>
          <div
            className={styles.left}
            style={{
              backgroundColor: hexToRgba('#4673D1', 0.1),
            }}
          >
            <Icons variant={Icons.INFO} />
          </div>
          <div
            className={styles.right}
          >{`${contactName} edited their notification preferences. Any further changes can only be made by the team member directly.`}</div>
        </div>
      )}
      <div className={styles.content}>
        <Notifications
          forTeamMember={true}
          userId={contactId}
          externalNotificationPref={notificationPref}
          disableTextNotification={disableTextNotification}
          disableAll={disableAll}
        />
      </div>
    </div>
  );
};

export default NotificationsContent;
